import { EstadoIncidenciaSeguridad } from "../shared/model/iso42001/incidencia-seguridad.model";

export interface IncidenciaSeguridadOption {
  value: string;
  label: string;
  description?: string;
}

export interface IncidenciaSeguridadColumn {
  estado: EstadoIncidenciaSeguridad;
  titulo: string;
  icon: string;
  color: string;
}

export const INCIDENCIA_SEGURIDAD_COLUMNS: IncidenciaSeguridadColumn[] = [
  { estado: "ABIERTO", titulo: "Abierto", icon: "mark_email_unread", color: "#b71c1c" },
  { estado: "PROCESO", titulo: "Proceso", icon: "settings_applications", color: "#ef6c00" },
  { estado: "ATENDIDO", titulo: "Atendido", icon: "fact_check", color: "#1976d2" },
  { estado: "VOBO", titulo: "Vo.Bo.", icon: "task_alt", color: "#2e7d32" },
  { estado: "CANCELADO", titulo: "Cancelado", icon: "cancel", color: "#64748b" },
];

export const TIPO_EVENTO_OPTIONS: IncidenciaSeguridadOption[] = [
  { value: "Legal", label: "Legal" },
  { value: "Operacional", label: "Operacional" },
  { value: "Derivada de la gestion de riesgos", label: "Derivada de la gestión de riesgos" },
  { value: "Relativa al Sistema de Gestion", label: "Relativa al Sistema de Gestión" },
];

export const GRAVEDAD_OPTIONS: IncidenciaSeguridadOption[] = [
  {
    value: "Critico",
    label: "Crítico",
    description:
      "El usuario no puede desarrollar sus funciones y no existen alternativas de operación disponibles.",
  },
  {
    value: "Medio",
    label: "Medio",
    description:
      "La función no realiza lo que debe realizar, pero existen alternativas de operación.",
  },
  {
    value: "Bajo",
    label: "Bajo",
    description:
      "Hay pérdida parcial de funciones del negocio y existen alternativas.",
  },
];

export const PRIORIDAD_OPTIONS: IncidenciaSeguridadOption[] = [
  {
    value: "Alta",
    label: "Alta",
    description: "Requiere atención inmediata para evitar impacto grave en el negocio.",
  },
  {
    value: "Media",
    label: "Media",
    description: "Es importante, pero permite un poco más de tiempo para su resolución.",
  },
  {
    value: "Baja",
    label: "Baja",
    description: "Se atiende al finalizar el trabajo más importante; aplica a incidentes menores.",
  },
];

export const TIPO_SOLUCION_OPTIONS: IncidenciaSeguridadOption[] = [
  {
    value: "SOLUCION_INMEDIATA",
    label: "SOLUCION INMEDIATA",
    description: "Debe estar compuesta de la resolución del problema surgido",
  },
  {
    value: "ACCION_CORRECTIVA",
    label: "ACCION CORRECTIVA",
    description: "La aplicación de acciones para evitar que dicho problema vuelva a repetirse",
  },
];
